module.exports = __webpack_public_path__ + "static/media/worabcdefghijklmnopqrstuvwxyzdle.6d8a9c7c.png";